import { useAppActions } from 'reducers/slices/bidRequestsSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { loadBidRequests } = useAppActions();
  const { loading, bidRequests, meta } = useSelector(state => state.bidRequestsSlice);

  return {
    loadBidRequests,
    bidRequests,
    loading,
    meta,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useBidRequests.js